import { render, staticRenderFns } from "./OrderRecordsComponent.vue?vue&type=template&id=651d8dfa&scoped=true"
import script from "./OrderRecordsComponent.vue?vue&type=script&lang=js"
export * from "./OrderRecordsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651d8dfa",
  null
  
)

export default component.exports